import {
  COINS_REGISTER,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  REGISTER_FAIL,
  REGISTER_SUCCESS,
} from 'store/types'

const user = JSON.parse(localStorage.getItem('user'))

const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null }

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case COINS_REGISTER:
      return {
        ...state,
        isLoggedIn: true,
        arkacoins: payload,
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload,
      }
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      }
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.data,
        fullname: payload.fullname,
      }
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        message: payload.message,
      }
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      }
    default:
      return state
  }
}
